import { render, staticRenderFns } from "./BackLogoIcon.vue?vue&type=template&id=7f39e28f&"
import script from "./BackLogoIcon.vue?vue&type=script&lang=js&"
export * from "./BackLogoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports